import { render, staticRenderFns } from "./indicator_by_year.vue?vue&type=template&id=4ee6e875"
import script from "./indicator_by_year.vue?vue&type=script&lang=js"
export * from "./indicator_by_year.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports